import React from 'react';
import styled from 'astroturf/react';

import { Author } from 'js/liswp/Sidebar/hooks/types';

import AboutTheAuthors from './AboutTheAuthorsSection';
import _Wrapper from "AboutTheAuthorsSSR-Wrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/sidebar_ds/AboutTheAuthorsSSR.tsx?styleId=Wrapper";


export type AboutTheAuthorsSSRProps = {
  authors: Author[];
  workId: number;
};

const triggerLoginModal = async (
  author: Author,
  workId: number,
  action: 'follow' | 'message',
) => {
  const { openLoginModal } = await import('js/login_modal/LoginModalManager');

  const actionText = action === 'follow' ? 'follow' : 'message';
  const actionTextCapitalized = action === 'follow' ? 'Follow' : 'Message';

  // FIXME: Fix login modal copy
  openLoginModal({
    postLoginRedirectUrl: window.location.href,
    clickTrackingContext: {
      source: `loswp-about-authors-${actionText}-${workId}`,
      entityId: author.id,
    },
    configuredText: {
      buttonsPage: { header: `${actionTextCapitalized} ${author.displayName}` },
      emailEntryPage: {
        subheader: `Sign up or log in to ${actionText} this author.`,
      },
      emailLoginPage: { subheader: `Log in to ${actionText} this author.` },
      emailRegistrationPage: {
        subheader: `Sign up to ${actionText} this author.`,
      },
    },
    registrationParams: {
      user_source: actionText,
    },
  });
};

const Wrapper = /*#__PURE__*/styled("div", null, {
  displayName: "Wrapper",
  styles: _Wrapper
});

const AboutTheAuthorsSSR: React.FC<AboutTheAuthorsSSRProps> = ({
  authors,
  workId,
}) => {
  const handleFollow = (author: Author) => {
    triggerLoginModal(author, workId, 'follow');
  };

  const handleMessage = (author: Author) => {
    triggerLoginModal(author, workId, 'message');
  };

  if (!authors || authors.length === 0) {
    return null;
  }

  return (
    <Wrapper>
      <AboutTheAuthors
        authors={authors}
        onFollow={handleFollow}
        onMessage={handleMessage}
        showViewAllPapersLink={true}
      />
    </Wrapper>
  );
};

export default AboutTheAuthorsSSR;
